<!-- 聚会页面 -->
<template>
  <div class="appointmentDiv">
    <div class="welcomeImgDIv">
      <img
        src="../../assets/image/btn_fanxiao.png"
        alt="欢迎回家"
        class="welcomeImg"
      />
    </div>
    <!-- 基本信息 -->
    <div class="inputDataDiv">
      <!-- <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">基本信息</div>
      </div> -->
      <div class="FirstLevelTitle titleDiv">
        <div>基本信息</div>
      </div>
      <div class="inputData">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="ruleForm"
          :hide-required-asterisk="true"
          label-position="left"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="主题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="人数" prop="personNum">
            <el-input v-model="ruleForm.num"></el-input>
          </el-form-item>
          <el-form-item label="开始日期" required>
            <el-form-item prop="start_time" style="margin: 0; width: 100%">
              <el-date-picker
                type="date"
                placeholder="年-月-日"
                v-model="ruleForm.start_time"
                style="width: 77%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="结束日期" required>
            <el-form-item prop="end_time" style="margin: 0; width: 100%">
              <el-date-picker
                type="date"
                placeholder="年-月-日"
                v-model="ruleForm.end_time"
                style="width: 77%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 服务信息 -->
    <div class="serviceDataDiv">
      <!-- <div class="titleDiv">
        <div class="titleIcon"></div>
        <div class="titleWord">服务信息</div>
      </div> -->
      <div class="serviceDiv">
        <span>学校可以为集体返校校友提供学生志愿者服务。</span>
        <span> 校内宾馆住宿提供优惠价格！</span>
      </div>
      <!-- <div class="serviceDiv">
        <div class="serviceTitle">策划活动</div>
        <div class="serviceSelect">
          <el-checkbox-group v-model="ruleForm.cehua">
            <el-checkbox label="聚会行程策划"></el-checkbox>
            <el-checkbox label="活动筹备"></el-checkbox>
            <el-checkbox label="活动执行"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="serviceDiv">
        <div class="serviceTitle">住宿需求</div>
        <div class="serviceSelect">
          <el-checkbox-group v-model="ruleForm.zhusu">
            <el-checkbox label="学校附近"></el-checkbox>
            <el-checkbox label="景区附近"></el-checkbox>
            <el-checkbox label="经济型"></el-checkbox>
            <el-checkbox label="度假村"></el-checkbox>
            <el-checkbox label="星级"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="serviceDiv">
        <div class="serviceTitle">用餐需求</div>
        <div class="serviceSelect">
          <el-checkbox-group v-model="ruleForm.yongcan">
            <el-checkbox label="中高档饭店"></el-checkbox>
            <el-checkbox label="大众饭店"></el-checkbox>
            <el-checkbox label="农家乐"></el-checkbox>
            <el-checkbox label="大排档"></el-checkbox>
            <el-checkbox label="轰趴馆"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="serviceDiv">
        <div class="serviceTitle">活动需求</div>
        <div class="serviceSelect">
          <el-checkbox-group v-model="ruleForm.huodong">
            <el-checkbox label="接站送站"></el-checkbox>
            <el-checkbox label="签到"></el-checkbox>
            <el-checkbox label="礼仪"></el-checkbox>
            <el-checkbox label="校园游览"></el-checkbox>
            <el-checkbox label="教师座谈会"></el-checkbox>
            <el-checkbox label="校园食堂聚餐"></el-checkbox>
            <el-checkbox label="主持"></el-checkbox>
            <el-checkbox label="晚会表演"></el-checkbox>
            <el-checkbox label="摄影"></el-checkbox>
            <el-checkbox label="摄像"></el-checkbox>
            <el-checkbox label="车辆"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="serviceDiv">
        <div class="serviceTitle">聚会用品</div>
        <div class="serviceSelect">
          <el-checkbox-group v-model="ruleForm.juhui">
            <el-checkbox label="聚会邀约片"></el-checkbox>
            <el-checkbox label="聚会宣传/预告片"></el-checkbox>
            <el-checkbox label="回顾微电影"></el-checkbox>
            <el-checkbox label="微信邀请函"></el-checkbox>
            <el-checkbox label="条幅"></el-checkbox>
            <el-checkbox label="展架"></el-checkbox>
            <el-checkbox label="会旗"></el-checkbox>
            <el-checkbox label="聚会背景墙"></el-checkbox>
            <el-checkbox label="聚会U盘"></el-checkbox>
            <el-checkbox label="纪念光盘"></el-checkbox>
            <el-checkbox label="聚会文化衫"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div> -->
      <div class="otherDiv">
        <!-- <div class="otherTitle">返校需求</div> -->
        <div class="FirstLevelTitle leftShift">
          <div>返校需求</div>
        </div>
        <div class="other">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleForm.other"
            rows="5"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </div>
      </div>
      <div class="remarksDiv">
        <!-- <div class="remarksTitle">备注</div> -->
        <div class="FirstLevelTitle leftShift">
          <div>备注</div>
        </div>
        <div class="remarks">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="ruleForm.remarks"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </div>
      </div>
      <div class="btnDiv">
        <button class="btn" @click="showPopup">提交</button>
      </div>

      <div class="popup">
        <!-- @open打开弹出层时触发 -->
        <van-popup
          v-model="show"
          round
          :style="{ height: '70%', width: '90%' }"
        >
          <div class="topImgDiv">
            <img
              src="../../assets/image/btn_shang_nor.png"
              alt="顶部图片"
              class="topImg"
            />
          </div>
          <div class="popupExplain">预约信息</div>
          <div class="popupExplainWords">
            <div class="popupInputDataDiv">
              <div class="popupInputDataTitle">基本信息</div>
              <div class="popupName">姓名：{{ this.ruleForm.name }}</div>
              <div class="popupPhone">手机：{{ this.ruleForm.phone }}</div>
              <div class="popupTitle">主题：{{ this.ruleForm.title }}</div>
              <div class="popupPersonNum">人数：{{ this.ruleForm.num }}</div>
              <div class="popupStartDate">
                日期：{{ this.ruleForm.start_time }}至{{
                  this.ruleForm.end_time
                }}
              </div>
              <!-- <div class="popupEndDate">
                结束日期：{{ this.ruleForm.end_time }}
              </div> -->
            </div>
            <div class="popupServiceDataDiv">
              <div class="popupServiceDataTitle">服务信息</div>
              <div class="popupPlanActive">
                策划活动：{{ this.ruleForm.cehua.toString().replace(/'/g, "") }}
              </div>
              <div class="popupStayNeeds">
                住宿需求：{{ this.ruleForm.zhusu.toString().replace(/'/g, "") }}
              </div>
              <div class="popupFoodNeeds">
                用餐需求：{{
                  this.ruleForm.yongcan.toString().replace(/'/g, "")
                }}
              </div>
              <div class="popupActiveNeeds">
                活动需求：{{
                  this.ruleForm.huodong.toString().replace(/'/g, "")
                }}
              </div>
              <div class="popupMeetingGoods">
                聚会用品：{{ this.ruleForm.juhui.toString().replace(/'/g, "") }}
              </div>
              <div class="popupOther">其他要求：{{ this.ruleForm.other }}</div>
              <div class="popupRemarks">备注：{{ this.ruleForm.remarks }}</div>
            </div>
          </div>
          <div class="popupCloseBtnDiv">
            <button class="popupCloseBtn" @click="closePopup">修改</button>
          </div>
          <div class="popupSubmitBtnDiv">
            <button class="popupSubmitBtn" @click="submit">确认</button>
          </div>
          <div class="bottomImgDiv">
            <img
              src="../../assets/image/btn_xia_nor.png"
              alt="底部图片"
              class="bottomImg"
            />
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      certificate: "",
      show: false,
      ruleForm: {
        user_id: window.localStorage.getItem("user_id"),
        name: "",
        phone: "",
        title: "",
        num: "1",
        start_time: "",
        end_time: "",
        cehua: [],
        zhusu: [],
        yongcan: [],
        remarks: "",
        other: "",
        juhui: [],
        huodong: [],
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 8,
            message: "长度在 1 到 8 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 1,
            max: 11,
            message: "长度在 1 到 11 个字符",
            trigger: "blur",
          },
          {
            type: "number",
            message: "手机号格式不正确",
            trigger: "blur",
            transform(value) {
              var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
              if (!phonereg.test(value)) {
                return false;
              } else {
                return Number(value);
              }
            },
          },
        ],
        title: [
          { required: true, message: "请输入主题", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        num: [
          { required: true, message: "请输入人数", trigger: "blur" },
          {
            min: 1,
            max: 5,
            message: "长度在 1 到 5 个数字",
            trigger: "blur",
          },
        ],
        start_time: [
          { required: true, message: "请输入开始日期", trigger: "blur" },
        ],
        end_time: [
          { required: true, message: "请输入结束日期", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    async submit() {
      const result = await this.$http({
        url: "/otherApplyinfos/insertReturnSchool",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          user_id: this.ruleForm.user_id,
          name: this.ruleForm.name,
          phone: this.ruleForm.phone,
          title: this.ruleForm.title,
          num: this.ruleForm.num,
          start_time: this.ruleForm.start_time,
          end_time: this.ruleForm.end_time,
          cehua: this.ruleForm.cehua.toString().replace(/'/g, ""),
          zhusu: this.ruleForm.zhusu.toString().replace(/'/g, ""),
          yongcan: this.ruleForm.yongcan.toString().replace(/'/g, ""),
          remarks: this.ruleForm.remarks,
          other: this.ruleForm.other,
          juhui: this.ruleForm.juhui.toString().replace(/'/g, ""),
          huodong: this.ruleForm.huodong.toString().replace(/'/g, ""),
        }),
      });
      this.certificate = result.data;
      if (this.certificate.msg == "success") {
        return this.$router.push("/appointmentSucc");
      } else {
        this.$toast("提交失败，请重试");
      }
    },
    showPopup() {
      this.$refs.ruleForm.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        this.show = true;
      });
    },
    closePopup() {
      this.show = false;
    },

    async getUserData() {
      const result = await this.$http.get("/otherApplyinfos/getBasicInfo", {
        params: { openid: window.localStorage.getItem("openid") },
      });
      this.ruleForm.name = result.data.name;
      if (result.data.phone !== "") {
        this.ruleForm.phone = result.data.phone;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.appointmentDiv {
  .welcomeImgDIv {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    // position: relative;
    .welcomeImg {
      width: 90%;
      height: 100%;
    }
  }
  .inputDataDiv {
    .inputData {
      display: flex;
      justify-content: center;
      .ruleForm {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 90%;
        margin-top: 10px;
        background-color: white;
        border-radius: 15px;
        .el-form-item {
          margin: 15px 0;
          width: 90%;
          .el-input {
            width: 86%;
            /deep/.el-input__inner {
              background-color: #f5f5f5;
            }
          }
        }
      }
    }
  }
  .serviceDataDiv {
    .serviceDiv {
      display: flex;
      flex-direction: column;
      .serviceTitle {
        margin-left: 5%;
        margin-top: 5px;
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
      }
      .serviceSelect {
        margin-left: 5%;
        margin-top: 5px;
      }
    }

    .serviceDiv :nth-child(1) {
      margin-top: 15px;
      color: #00706e;
      position: relative;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
    }
    .serviceDiv :nth-child(2) {
      color: #00706e;
      position: relative;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      margin-top: 5px;
      margin-bottom: 10px;
      // margin-left: 10%;
    }
  }
  .otherDiv {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    .otherTitle {
      margin-left: 5%;
      margin-top: 5px;
      font-size: 1.1rem;
      font-weight: bold;
      // color: #333333;
    }
    .other {
      width: 90%;
      margin-left: 5%;
      margin-top: 10px;
    }
  }
  .remarksDiv {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    .remarksTitle {
      margin-left: 5%;
      margin-top: 5px;
      font-size: 1.1rem;
      // font-weight: bold;
      color: #333333;
    }
    .remarks {
      width: 90%;
      margin-left: 5%;
      margin-top: 10px;
    }
  }
  .btnDiv {
    display: flex;
    justify-content: center;
    margin: 30px 0;
    .btn {
      width: 90%;
      padding: 10px 0;
      background: linear-gradient(270deg, #00706e, #00706e);
      border: 0;
      border-radius: 30px;
      color: white;
      font-size: 1.1rem;
    }
  }
}
.titleDiv {
  margin-left: 5%;
  height: 7vw;
  display: flex;
  width: 90%;
  margin-top: 30px;
  .titleIcon {
    width: 4px;
    height: 6vw;
    background-color: #00706e;
    border-radius: 15px;
  }
  .titleWord {
    padding-left: 10px;
    font-size: 1.3em;
    font-weight: bold;
    color: #333333;
  }
}
.el-checkbox {
  margin-top: 5px;
  margin-bottom: 5px;
}
.popup {
  position: relative;
}
.topImgDiv {
  width: 100%;
}
.topImg {
  width: 100%;
}
.bottomImgDiv {
  width: 100%;
}
.bottomImg {
  width: 100%;
  position: absolute;
  top: 100%;
  transform: translateY(-100%);
}
.popupExplain {
  font-size: 1.2em;
  color: #00706e;
  text-align: center;
  font-weight: bold;
}
.popupExplainWords {
  position: relative;
  left: 5%;
  width: 90%;
  height: 67%;
  background: #f5f5f5;
  border-radius: 15px;
  overflow-y: scroll;
}
.popupExplainWords::-webkit-scrollbar {
  display: none;
}
.popupWelfareExplainWords {
  position: relative;
  left: 5%;
  top: 5%;
  width: 90%;
  overflow-y: scroll;
  background-color: #f5f5f5;
  border-radius: 15px;
}
.popupWelfareName {
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
  padding: 10px 0px 5px 10px;
}
.popupWelfareAdress {
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.popupWelfareService {
  color: #666666;
  padding: 5px 10px 10px 10px;
}
.popupWelfareTips {
  position: relative;
  top: 15%;
  text-align: center;
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
}
.popupWelfareBtnDiv {
  position: absolute;
  top: 72%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}
.popupCloseBtnDiv {
  position: absolute;
  top: 82%;
  left: 5%;
  width: 40%;
}
.popupCloseBtn {
  width: 100%;
  border: 1px solid #00706e;
  background: white;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706e;
  padding: 8px 0 8px 0;
  border-radius: 45px;
}
.popupSubmitBtnDiv {
  position: absolute;
  top: 82%;
  right: 5%;
  width: 40%;
}
.popupSubmitBtn {
  width: 100%;
  border: 0;
  background: linear-gradient(270deg, #00706e, #00706e);
  font-size: 1.2em;
  font-weight: bold;
  color: white;
  padding: 8px 0 8px 0;
  border-radius: 45px;
}
.popupInputDataTitle,
.popupServiceDataTitle {
  margin: 10px 0 0 5px;
  color: #333333;
  font-weight: bold;
  font-size: 1.1rem;
}
.popupName,
.popupPhone,
.popupTitle,
.popupPersonNum,
.popupStartDate,
.popupEndDate,
.popupPlanActive,
.popupStayNeeds,
.popupFoodNeeds,
.popupActiveNeeds,
.popupMeetingGoods,
.popupOther,
.popupRemarks {
  margin: 5px 0 0px 5px;
  color: #333333;
}
.popupServiceDataDiv {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/backSchool/Appointment.vue